<template>
  <div class="page-stable"><slot></slot></div>
</template>

<script>
export default {
  name: 'PageStable',

  data() {
    return {
      container: null
    }
  },

  mounted() {
    this.setStable()
  },
  activated() {
    this.setStable()
  },

  deactivated() {
    this.removeStable()
  },

  beforeDestroy() {
    this.removeStable()
  },

  methods: {
    setStable() {
      this.container = document.querySelector('.app-main')
      this.container.classList.add('stable-app')
    },
    removeStable() {
      if (this.container) {
        this.container.classList.remove('stable-app')
        this.container = null
      }
    }
  }
}
</script>

<style lang="less" scoped>
.page-stable {
  height: 100%;
  padding: 24px;
  display: flex;
  flex-direction: column;
}
</style>
